<template>
  <div>
    <Form
      ref="editModel"
      :model="editModel"
      :rules="ruleValidate"
      :label-width="100"
    >
      <FormItem label="设备SN码" prop="clientSN">
        <Input
          v-model="editModel.clientSN"
          readonly
          placeholder="设备SN码唯一"
        ></Input>
      </FormItem>
      <!-- <FormItem label="服务名" prop="parmTitletext">
        <Input v-model="editModel.parmTitletext" readonly></Input>
      </FormItem> -->
      <FormItem label="服务名" prop="parmTitle">
        <Input v-model="editModel.parmTitle" readonly></Input>
      </FormItem>

      <FormItem label="类型" prop="parmType">
        <Input v-model="editModel.parmType" readonly></Input>
      </FormItem>
      <FormItem label="状态" prop="status">
        <Select v-model="editModel.status">
          <Option value="0" selected>开启</Option>
          <Option value="1">关闭</Option>
          <!-- <Option value="2">重启</Option> -->
        </Select>
      </FormItem>
      <!-- <FormItem label="参数key" prop="parmName">
        <Input v-model="editModel.parmName"></Input>
      </FormItem> -->
      <FormItem label="参数value" prop="parmValue">
        <Input
          v-model="editModel.parmValue"
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 15 }"
        ></Input>
      </FormItem>
      <FormItem label="参数描述">
        <Input
          v-model="editModel.parmDescription"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 5 }"
        ></Input>
      </FormItem>
    </Form>
    <div class="text-center modal-foter">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="handleSubmit('editModel')"
        >确 定</Button
      >
    </div>
  </div>
</template>
<script>
//import func from "vue-editor-bridge";
export default {
  props: ["currentData"],
  components: {},
  data: function () {
    return {
      editModel: {
        clientSN: "",
        parmName: "",
        parmValue: "",
        parmDescription: "",
        status: "0",
      },
      ruleValidate: {
        clientSN: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        // parmName: [
        //   {
        //     required: true,
        //     message: "不能为空",
        //   },
        // ],
        parmValue: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        status: [
          {
            required: true,
            message: "不能为空",
          },
        ],
      },
    };
  },

  created: function () {
    console.log("created :" + JSON.stringify(this.currentData));
    this.editModel = this.currentData;
    this.editModel.status = this.editModel.status.toString();
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },

    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          this.$api.post("clientXml/update", this.editModel).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("更新成功");
              this.returnBack();
              this.resetData();
              this.$emit("loadData");
              this.$emit("search_fuwu");
            }
          });
        }
      });
    },

    resetData() {
      for (let key in this.editModel) {
        this.editModel[key] = "";
      }
      this.$refs["editModel"].resetFields();
    },
  },
};
</script>
<style scoped>
</style>